/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { strategiesGetStrategies } from "../../funcs/strategiesGetStrategies.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetStrategiesRequest$inboundSchema,
};

export const tool$strategiesGetStrategies: ToolDefinition<typeof args> = {
  name: "strategies-get-strategies",
  description: `Get a list of all strategies

Returns a list of all strategies. Strategies are trading strategies with associated trajectories and horizons. Optionally filter by strategy name.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await strategiesGetStrategies(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
